import { cardItems } from '@/mocks/home';

const cardImages: Record<string, string> = {
  'card-01': 'https://readdy.ai/api/search-image?query=Manga%20fantasy%20comic%20cover%20featuring%20young%20warrior%20character%20with%20blue%20silver%20hair%20in%20ornate%20battle%20armor%20standing%20on%20mountain%20peak%20with%20glowing%20spirit%20ring%20effects%20warm%20orange%20golden%20sky%20dramatic%20anime%20cover%20art%20style%20professional%20composition&width=400&height=560&seq=card-01&orientation=portrait',
  'card-02': 'https://readdy.ai/api/search-image?query=Manga%20supernatural%20comic%20cover%20featuring%20mysterious%20girl%20character%20with%20long%20flowing%20hair%20and%20cold%20expression%20surrounded%20by%20ethereal%20energy%20effects%20urban%20fantasy%20setting%20warm%20amber%20and%20coral%20tones%20professional%20anime%20cover%20art%20style&width=400&height=560&seq=card-02&orientation=portrait',
  'card-03': 'https://readdy.ai/api/search-image?query=Manga%20romance%20fantasy%20comic%20cover%20featuring%20beautiful%20fox%20spirit%20girl%20with%20ears%20and%20tail%20in%20flowing%20traditional%20red%20dress%20with%20cherry%20blossom%20petals%20soft%20warm%20peach%20and%20coral%20color%20palette%20shojo%20anime%20cover%20art%20style%20elegant%20dreamy%20composition&width=400&height=560&seq=card-03&orientation=portrait',
  'card-04': 'https://readdy.ai/api/search-image?query=Manga%20historical%20martial%20arts%20comic%20cover%20featuring%20rugged%20warrior%20character%20with%20sword%20standing%20in%20desert%20sandstorm%20dramatic%20pose%20with%20flowing%20cape%20warm%20sandy%20orange%20and%20amber%20tones%20seinen%20manga%20cover%20art%20style%20intense%20atmosphere&width=400&height=560&seq=card-04&orientation=portrait',
  'card-05': 'https://readdy.ai/api/search-image?query=Manga%20esports%20gaming%20comic%20cover%20featuring%20cool%20confident%20young%20character%20holding%20gaming%20gear%20with%20competitive%20determined%20expression%20neon%20warm%20orange%20and%20amber%20lighting%20cyberpunk%20inspired%20anime%20cover%20art%20style%20dynamic%20composition&width=400&height=560&seq=card-05&orientation=portrait',
  'card-06': 'https://readdy.ai/api/search-image?query=Manga%20supernatural%20action%20comic%20cover%20featuring%20fierce%20guardian%20warrior%20character%20with%20fiery%20spirit%20companion%20in%20ancient%20Chinese%20fantasy%20setting%20warm%20red%20and%20orange%20flame%20effects%20professional%20anime%20cover%20art%20style%20with%20dynamic%20battle%20pose&width=400&height=560&seq=card-06&orientation=portrait',
};

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">推荐漫画</h2>
          <p className="text-sm md:text-base text-foreground-500">精选热门漫画推荐，总有一部适合你</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {cardItems.map((item) => (
            <a
              key={item.seq}
              href="#hero"
              className="flex flex-col bg-background-100 rounded-xl overflow-hidden group cursor-pointer"
            >
              <div className="relative w-full aspect-[3/4] overflow-hidden">
                <img
                  src={cardImages[item.seq]}
                  alt={`${item.title} 漫画封面`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className="text-xs px-1.5 py-0.5 rounded bg-accent-500 text-background-50 font-medium">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                  <div className="text-xs text-background-50 font-medium">{item.status}</div>
                </div>
              </div>
              <div className="p-3 flex flex-col flex-1">
                <h3 className="font-semibold text-foreground-950 text-sm mb-1 group-hover:text-primary-500 transition-colors truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-1">{item.author}</p>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 flex-1 mb-2">{item.desc}</p>
                <div className="flex items-center justify-between text-xs">
                  <span className="text-foreground-500">{item.chapters}</span>
                  <span className="flex items-center gap-1 text-accent-500">
                    <i className="ri-fire-line"></i>
                    {item.heat}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}